import React from "react";

const AdminDashboard: React.FC = () => {
  return (
    <div className="container mt-5 p-3">
      <div className="text-center ">
        <h2 className="fw-bold">Welcome to the Admin Panel</h2>
        <p className="lead text-muted">Nestfin </p>
      </div>
    </div>
  );
};

export default AdminDashboard;
